(function () {
  var isCleaning = false;

  function jsonFetch(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () {
          return {};
        }).then(function (error) {
          throw new Error(error.description || error.message || 'Cart request failed');
        });
      }

      return response.json();
    });
  }

  function cleanAddonCartItems(options) {
    if (isCleaning) return Promise.resolve(false);

    isCleaning = true;
    options = options || {};

    return fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to fetch cart');
        return response.json();
      })
      .then(function (cart) {
        var addonItems = cart.items
          .map(function (item, index) {
            item.line = index + 1;
            return item;
          })
          .filter(function (item) {
            return item.properties && item.properties._type === 'addon';
          })
          .sort(function (a, b) {
            return b.line - a.line;
          });

        if (!addonItems.length) return false;

        return addonItems.reduce(function (chain, item) {
          return chain
            .then(function () {
              return jsonFetch('/cart/add.js', {
                id: item.variant_id,
                quantity: item.quantity
              });
            })
            .then(function () {
              return jsonFetch('/cart/change.js', {
                line: item.line,
                quantity: 0
              });
            });
        }, Promise.resolve()).then(function () {
          if (options.reload !== false) {
            window.location.reload();
          }

          return true;
        });
      })
      .catch(function (error) {
        console.error('[Cart Addon Cleaner]', error);
        return false;
      })
      .finally(function () {
        isCleaning = false;
      });
  }

  window.cleanAddonCartItems = cleanAddonCartItems;

  document.addEventListener('DOMContentLoaded', function () {
    if (document.body && document.body.classList.contains('template-cart')) {
      cleanAddonCartItems();
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-clean-addon-cart]');

      if (!trigger) return;

      event.preventDefault();
      cleanAddonCartItems();
    });
  });
})();
